import { memo } from 'react'


const CreateInSights = memo(() => {

    return(
        <div className="mt-5">
            <h1>Campaign / media-buying / Insights / Creative Insights</h1>
        </div>
    )

})


export default CreateInSights